import React from 'react';
import { render, waitFor } from '@testing-library/react';
import '@testing-library/jest-dom/extend-expect';
import { AnvilSelect } from './';

const dummyOptions = [
	{
		text: 'Jane Doe',
		value: 1,
		disabled: true,
	},
	{
		text: 'Bob Ross',
		value: 2,
	},
	{
		text: 'Jackie Robinson',
		value: 3,
	},
	{
		text: 'Alexandria Garcia',
		value: 4,
	},
	{
		text: 'Zack Bower',
		value: 5,
	},
	{
		text: 'Erin Smith',
		value: 6,
	},
	{
		text: 'Jarrod Saltalamacchia',
		value: 7,
	},
	{
		text: 'Natalia McPhearson',
		value: 8,
	},
	{
		text: 'Valente Zero',
		value: 0,
	},
];

describe('AnvilSelect', () => {
	beforeEach(() => {
		global.innerWidth = 400;
		global.innerHeight = 2000;
		global.dispatchEvent(new Event('resize'));
	});

	it('trigger should show X selected if rows is 0', () => {
		const selectedCount = 1;
		const props = {
			options: dummyOptions,
			value: dummyOptions.slice(0, selectedCount),
			trigger: {
				placeholder: 'Select several technicians',
				rows: 0,
			},
			multiple: true,
		};
		const { getByText } = render(<AnvilSelect {...props} />);

		expect(getByText(`${selectedCount} selected`)).toBeInTheDocument();
	});

	it.skip('should pass through data automation attributes', () => {
		const selectedCount = 1;
		const props = {
			options: dummyOptions,
			value: dummyOptions.slice(0, selectedCount),
			trigger: {
				placeholder: 'Select several technicians',
				rows: 0,
			},
			multiple: true,
		};

		const { container } = render(
			<AnvilSelect {...props} data-auto-sel="automation-selector" />
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});

	it('should respect actionButtonProps on footer', async () => {
		const props = {
			open: true,
			footer: {
				actionName: 'Submit',
				actionButtonProps: {
					// eslint-disable-next-line no-useless-computed-key
					['data-testid']: 'submit-button',
					disabled: true,
				},
				onActionClick: () => {},
			},
		};

		const { getByTestId } = render(<AnvilSelect {...props} />);

		await waitFor(() => {
			expect(getByTestId('submit-button')).toBeInTheDocument();
		});
		const element = getByTestId('submit-button');

		expect(element).toHaveAttribute('disabled');
	});
});
